import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ViewerAsset } from '@models/viewer-asset';
import { DrawingTools } from '@shared/drawing/drawing';

@Component({
  template: `<div></div>`,
  standalone: false
})
export abstract class ViewerBaseComponent {
  @Input() asset: ViewerAsset;
  @Input() series: string;
  @Input() grade: string;
  @Input() selectedTool: DrawingTools = DrawingTools.none;
  @Input() zoomLevel = 100;
  @Output() loaded: EventEmitter<void> = new EventEmitter<void>();
  @Output() withError: EventEmitter<any> = new EventEmitter<any>();
  @Output() completed: EventEmitter<void> = new EventEmitter<void>();
}
